import { connect } from 'react-redux';
import { IMoveToPanelButtonHOCProps } from './types';
import { onClick } from './events/onClick';
import { MoveToPanelButton } from '../../components/MoveToPanelButton/MoveToPanelButton';
import { IMoveToPanelButtonEvents, IMoveToPanelButtonFields } from '../../components/MoveToPanelButton/types';
import { IApplicationState } from '../../../../../../../../types/types';
import { getBoardPermissions } from '../../../../../../../../store/model/selectors/getBoardPermissions';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IMoveToPanelButtonHOCProps
): IMoveToPanelButtonFields => {
    const boardPermissions = getBoardPermissions(state, boardId);
    return {
        isShow: boardPermissions && boardPermissions.authPermissions && boardPermissions.authPermissions.allowMoveThisBoard,
    }
};

const mapDispatchToProps = (
    dispatch: any,
    { onClick: ownOnClick }: IMoveToPanelButtonHOCProps
): IMoveToPanelButtonEvents => {
    return {
        onClick: () => dispatch(onClick(ownOnClick))
    }
};

export const MoveToPanelButtonHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(MoveToPanelButton);
